import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Banner.css';
import phoneImage from './assets/phone.png';

interface IProps {
  text: string;
}

export const Banner: React.FunctionComponent<IProps> = ({ text }) => (
  <div className={`${styles['banner']}`}>
    <ArticleParagraph2>{text}</ArticleParagraph2>
    <img src={phoneImage} className={styles['banner_image']} alt="Телефон" />
  </div>
);
